/*
 * $Id:: UAMultiFilter.js 2021/02/26 06:09 otsolka
 *
 *        . * .
 *      * RRRR  *   Copyright (c) 2012-2021 EUIPO: European Intelectual
 *     .  RR  R  .  Property Organization (trademarks and designs).
 *     *  RRR    *
 *      . RR RR .   ALL RIGHTS RESERVED
 *       *. _ .*
 *
 *  The use and distribution of this software is under the restrictions exposed in 'license.txt'
 */

import React from 'react';

import Chip from '@material-ui/core/Chip';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import { makeStyles } from '@material-ui/core/styles';

import { ReactComponent as CaretDouble } from '../../assets/images/caretDouble.svg';
import { t } from '../../providers';

const useStyles = makeStyles(() => ({
    valueWithChip: {
        display: 'flex',
        alignItems: 'center',
        height: '100%',
    },
    textInput: {
        height: '2rem',
        width: 'auto',
        marginRight: '10px',
        marginBottom: '2px',
        '& .MuiSelect-select': {
            borderRadius: '4px',
        },
        '& .MuiSelect-icon': {
            top: 'calc(50% - 6px)',
        },
        '@media (max-width:960px)': {
            marginTop: '11px',
            marginRight: '10px',
            marginBottom: 'unset',
        },
        '@media (max-width:600px)': {
            width: '9.5rem',
        },
    },
    chip: {
        color: '#455A64',
        backgroundColor: '#F1F2F5',
        height: '18px',
        width: '24px',
        display: 'flex',
        justifyContent: 'center',
        marginLeft: '1rem',
        boxShadow: 'none',
        '& .MuiChip-label': {
            padding: 0,
        },
    },
}));

const UAMultiFilter = ({ filter = {}, handleFilterChange }) => {
    const classes = useStyles();

    const { value, _selectedItems, filterOptions, placeholder, multiple, ...props } = filter;

    const renderValue = (value) => {
        if (value.length) {
            return (
                <div className={classes.valueWithChip}>
                    <span>{t(placeholder)}</span>
                    <Chip className={classes.chip} label={multiple ? value.length : '1'} />
                </div>
            );
        } else return t(placeholder);
    };

    const handleSelect = (event) => {
        const translatable = filterOptions.some((option) => typeof option === 'object');
        const optionSelected = translatable
            ? filterOptions
                  .filter(({ key }) => event.target.value.includes(key))
                  .map(({ label, key }) => !!key && label)
                  .filter((item) => typeof item === 'string') //remove non-strings from values
            : event.target.value;
        handleFilterChange(event, optionSelected);
    };

    const displayOption = (option) => {
        let filterValue = { key: '', label: '' };
        if (typeof option === 'string') {
            filterValue = { key: option, label: option };
        } else if (typeof option === 'object') filterValue = { key: option.key, label: t(option.label) };
        return filterValue;
    };

    return (
        <Select
            {...props}
            id={`filter-input-${filter.name}`}
            className={`${classes.textInput} ${classes.selectWidth}`}
            displayEmpty
            IconComponent={CaretDouble}
            value={value || []}
            onChange={handleSelect}
            multiple={multiple}
            MenuProps={{
                getContentAnchorEl: () => null,
            }}
            renderValue={renderValue}>
            {(filterOptions || []).map((option, idx) => {
                let filterValue = displayOption(option);

                return (
                    <MenuItem
                        id={`filter-${filter.name}-option-${idx}`}
                        key={`${filterValue.key}_${idx}`}
                        value={!multiple && idx === 0 ? '' : filterValue.key}>
                        {filterValue.label}
                    </MenuItem>
                );
            })}
        </Select>
    );
};

export default UAMultiFilter;
